import React, {useState} from 'react';
import {Button, Modal, Spinner} from "react-bootstrap";
import {toast} from "react-toastify";
import {GhgEmissionPeriod, translateServerError} from "../models";
import {GhgEmissionPeriodsService} from '../GhgEmissionPeriods.service';

interface DeleteGhgEmissionPeriodConfirmModalProps {
    period: GhgEmissionPeriod;
    handleSubmitClose: () => void;
    handleRejectClose: () => void;
}

export function DeleteGhgEmissionPeriodConfirmModal(props: DeleteGhgEmissionPeriodConfirmModalProps) {
    const [saving, setSaving]: [boolean, any] = useState(false);
    const [savingError, setSavingError]: [boolean, any] = useState(false);

    const confirmSubmit = async () => {
        setSaving(true);
        setSavingError(false);

        try {
            await GhgEmissionPeriodsService.deleteGhgEmissionPeriod(props.period.id)
            setTimeout(() => {
                setSaving(false);
                props.handleSubmitClose();
            }, 100);
            toast("Perioodi kustutamine õnnestus", {
                position: "top-right",
                type: 'success'
            });
        } catch (e: any) {
            console.error('Saving failed', e);
            setSaving(false);
            setSavingError(true);
            toast(translateServerError(e, "Perioodi kustutamine ebaõnnestus"), {
                position: "top-right",
                type: 'error'
            });
        }
    };

    const rejectSubmit = () => {
        props.handleRejectClose();
    };

    return (
        <>
            <Modal
                show={true}
                centered
            >
                <Modal.Header>
                    <Modal.Title>
                        Perioodi kustutamine
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    Kas oled kindel, et soovid perioodi kustutada?
                </Modal.Body>
                <Modal.Footer className="d-flex flex-row align-items-end justify-content-around flex-wrap mb-1">
                    <Button variant="info"
                            onClick={() => rejectSubmit()}
                            type="button"
                            className={"d-flex align-items-center"}>
                        <span className='px-2'>Loobu</span>
                    </Button>
                    <Button variant="danger"
                            onClick={confirmSubmit}
                            type="button"
                            className="d-flex align-items-center">
                        {
                            !saving &&
                            <span className='px-2'>Kustuta</span>
                        }
                        {
                            saving &&
                            <>
                                <span className='px-2'>Kustutamine…</span>
                                <Spinner size={"sm"} animation={"border"}/>
                            </>
                        }
                    </Button>
                </Modal.Footer>
                {
                    !saving && savingError &&
                    <span className="d-flex justify-content-end text-danger px-2 pb-2">
                        Viga salvestamisel, proovi mõne hetke pärast uuesti.
                    </span>
                }
            </Modal>
        </>
    );
}
